module.exports = __webpack_public_path__ + "img/activities-13.bc47edf2.jpg";